/* eslint-disable no-unused-vars */

import axios from "axios";
import { Delete, Get, Post, PostFormData, Put, PutFormData } from "../Request";
export default {
  state: {
    Forums: [],
    previewItem: null,
    ForumComments: [],
    TotalForumsComment: 0,
    PreviewForum: null,
    ForumCategories: [],
    ForumDataById: null,
    Users:[],
    ForumByFilter:[]
  },
  getters: {
    GetUsers(state) {
      return state.Users;
    },
    GetForumByFilter(state) {
      return state.ForumByFilter;
    },
    GetForum(state) {
      return state.Forums;
    },
    GetForumCategories(state) {
      return state.ForumCategories;
    },
    GetPreview(state) {
      return state.previewItem;
    },
    GetForumComments(state) {
      return state.ForumComments;
    },
    GetTotalForumsComment(state) {
      return state.TotalForumsComment;
    },
    GetPreviewForum(state) {
      return state.PreviewForum;
    },
    GetForumById(state) {
      return state.ForumDataById;
    },
  },
  actions: {
    async ToggleVisiblityComment({ commit }, payload) {
      return await Post(`Forum/ToggleVisiblityComment?Id=${payload}`).then(
        (res) => {
          return res.data;
        }
      );
    },
    async AddSubCategory({ commit }, payload) {
      return await PostFormData("Forum/AddSubCategory", payload).then((res) => {
        return res.data;
      });
    },
    async EditSubCategory({ commit }, payload) {
      return await PutFormData("Forum/EditSubCategory", payload).then((res) => {
        return res.data;
      });
    },
    async GetForumCategories({ commit }, payload) {
      return await Get(`Forum/GetForumCategories`).then((res) => {
        commit("SetForumCategories", res.data.Data);
      });
    },
    async CreateForum({ commit }, payload) {
      return await PostFormData("Forum/AddForum", payload).then((res) => {
        return res.data;
      });
    },
    async UploadForumImage({ commit }, payload) {
      var form = new FormData();
      form.append("File", payload);
      return PostFormData("Forum/UploadForumImages", form).then((res) => {
        return res.data.Data;
      });
    },
    async DeleteForumImage({ commit }, payload) {
      var form = new FormData();

      form.append("File", payload);
      return PostFormData("Forum/DeleteForumImage", form).then(() => {});
    },
    async EditForum({ commit }, payload) {
      try {
        const response = await PutFormData("Forum/EditForum", payload);
        return response.data;
      } catch (error) {
        console.error("Error editing forum:", error);
        throw error;
      }
    },
    async GetForumById({ commit }, payload) {
      return await Get(`Forum/GetForumById/${payload}`).then((res) => {
        commit("SetPreviewForm", res.data.Data);
        return res.data.Data;
      });
    },
    async GetForumByFilter({ commit }, payload) {
      return await Get(
        `Forum/GetForumSubmittedByFilter/1?pageSize=all`
      ).then((res) => {
        commit("SetForumByFilter", res.data.Data);
        return res.data.Data;
      });
    },
    async GetForum({ commit }, payload) {
      return await Get(
        `Forum/GetForums/${
          payload.pageSize == "10000" ? 1 : payload.page
        }?pageSize=${payload.pageSize}&search=${payload.search}&filters=${
          payload.filters
        }`
      ).then((res) => {
        commit("SetForum", res.data.Data);
        return res.data.Data;
      });
    },
    async GetForumComments({ commit }, payload) {
      return await Get(
        `Forum/GetForumComments/${payload.page}?pageSize=${payload.pageSize}&forumId=${payload.forumId}`
      ).then((res) => {
        commit("SetForumComments", res.data.Data);
        return res.data.Data;
      });
    },
    // async GetForumsComments({ commit }, payload) {
    //   return await Get(
    //     `Forum/GetForumComments/${payload.page}?pageSize=${payload.pageSize}`
    //   ).then((res) => {
    //     commit("SetForum", res.data.Data);
    //     return res.data.Data;
    //   });
    // },
    async DeleteForum({ commit }, payload) {
      return await Delete(`Forum/DeleteForum/${payload}`).then((res) => {
        return res;
      });
    },
    async RemveSubCategory({ commit }, payload) {
      return await Delete(`Forum/RemveSubCategory/${payload}`).then((res) => {
        return res;
      });
    },
    async DeleteForumComment({ commit }, payload) {
      return await Delete(`Forum/DeleteForumComment/${payload}`).then((res) => {
        return res;
      });
    },
    async TogglePin({ commit }, payload) {
      var form = new FormData();
      form.append("Id", payload);
      return await PostFormData("Forum/TogglePin", form).then((res) => {
        return res.data.data;
      });
    },
    async ToggleVisiblity({ commit }, payload) {
      var form = new FormData();
      form.append("Id", payload);
      return await PostFormData("Forum/ToggleVisiblity", form).then((res) => {
        return res.data;
      });
    },
    async GetPreview({ commit }, payload) {
      commit("SetPreview", payload);
    },
    async SortForumCategory({ commit }, payload) {
      return await Post(
        `Forum/SortForumCategory?sortNum=${payload.sortNum}&Id=${payload.Id}`
      ).then((res) => {
        return res.data;
      });
    },
    async SortForumSubCategory({ commit }, payload) {
      return await Post(
        `Forum/SortForumSubCategory?sortNum=${payload.sortNum}&Id=${payload.Id}&categoryId=${payload.categoryId}`
      ).then((res) => {
        return res.data;
      });
    },
    async GetAllUsers({ commit }, payload) {
      return await Get(`User/getall?pageNumber=1&pageSize=all&search=&filters=`)
        .then((res) => {
          commit("SetUsers", res.data.Data.users);
          return res.data.Data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  mutations: {
    SetUsers(state, payload) {
      state.Users = payload
    },
    SetPreview(state, payload) {
      state.previewItem = payload;
    },

    SetForumComments(state, payload) {
      payload = payload.List.map((x) => {
        x.SubmittedByProfileImage =
          x.SubmittedByProfileImage != null &&
          x.SubmittedByProfileImage != undefined &&
          x.SubmittedByProfileImage != ""
            // ? process.env.VUE_APP_IMG_URL + "/" + x.SubmittedByProfileImage
            ? x.SubmittedByProfileImage
            : x.SubmittedByProfileImage;
        return x;
      });
      state.ForumComments = payload;
      state.TotalForumsComment = payload.totalRecords;
      // state.TotalForumsComment = payload.totalRecords;
    },
    SetForum(state, payload) {
      state.Forums = payload ? payload.List : [];
    },
    SetForumByFilter(state, payload) {
      state.ForumByFilter = payload;
    },
    SetPreviewForm(state, payload) {
      payload.ImgVid =
        payload.ImgVid != null &&
        payload.ImgVid != undefined &&
        payload.ImgVid != ""
          // ? process.env.VUE_APP_IMG_URL + "/" + payload.ImgVid
          ? payload.ImgVid
          : payload.ImgVid;
      payload.SubmittedByProfileImage =
        payload.SubmittedByProfileImage != null &&
        payload.SubmittedByProfileImage != undefined &&
        payload.SubmittedByProfileImage != ""
          // ? process.env.VUE_APP_IMG_URL + "/" + payload.SubmittedByProfileImage
          ? payload.SubmittedByProfileImage
          : payload.SubmittedByProfileImage;
      state.PreviewForum = payload;
      state.ForumDataById = payload;
    },
    SetForumCategories(state, payload) {
      state.ForumCategories = payload;
    },
  },
};
